<section class="wrapper bg-light wrapper-border content-wrapper">
    <div class="brand col-md-11 col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center">
        <h2 class="default-pattern-color display-2 mb-4">{{landingPageData?.clients.title}}</h2>
        <p class="lead fs-lg mb-11">{{landingPageData?.clients.description}}</p>
    </div>
    <div class="keen-slider" #sliderRef>
        <div *ngFor="let brand of landingPageData?.clients?.list; let i = index" class="keen-slider__slide number-slide1 img-container">
            <img class="img" dynamicImage *ngIf="brand?.img" [baseImageSrc]="brand?.img" [displayResolutions]="[IMAGES_RESOLUTIONS.xxs, IMAGES_RESOLUTIONS.xs]" alt="{{brand?.title}}" />
        </div>
    </div>

</section>

